import './index.css';
var styles = {"wt-icon":"_wt-icon_0xycl","xs":"_xs_slss","s":"_s_9gmc4","m":"_m_tjvq4i","l":"_l_qmvaw","light":"_light_uz4rwg","dark":"_dark_1gt8d"};

export { styles as default };
